import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enLocales from "./en/translation.json";
import plLocales from "./pl/translation.json";
import { Storage } from "src/utils/storage";

i18n.use(initReactI18next).init({
    resources: {
        pl: { translations: plLocales },
        en: { translations: enLocales },
    },
    lng: Storage.getItem("i18nextLng") || "pl",
    fallbackLng: "pl",
    debug: false,
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
